import { Button } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import { useModal } from 'context/ModalProvider/ModalProvider';
import useStyles from 'features/Events/components/EventsChart/EventsModal/EventsModal.styles';
import EventsModalDateTime from 'features/Events/components/EventsChart/EventsModal/EventsModalDateTime/EventsModalDateTime';
import EventsModalDetail from 'features/Events/components/EventsChart/EventsModal/EventsModalDetail/EventsModalDetail';
import EventsModalTitle from 'features/Events/components/EventsChart/EventsModal/EventsModalTitle/EventsModalTitle';
import { EventData } from 'features/Events/types/eventData';

export const EventsModal = (eventData: EventData) => {
  const { setShowModal } = useModal();
  const classes = useStyles();

  const spotTimeDate = eventData.spotTime ? new Date(eventData.spotTime) : undefined;
  const spotTime = spotTimeDate
    ? `${spotTimeDate.getHours()}:${
        (spotTimeDate.getMinutes() < 10 ? '0' : '') + spotTimeDate.getMinutes()
      }`
    : undefined;

  return (
    <div className={classes.modal}>
      <EventsModalTitle event={eventData.event} />
      <EventsModalDateTime eventTime={eventData.time} />
      {eventData.adId && (
        <EventsModalDetail label={'Ad ID: '} value={eventData.adId} textSeparator={true} />
      )}
      {eventData.spotTime && (
        <EventsModalDetail label={'Spot Time: '} value={spotTime || ''} textSeparator={false} />
      )}
      {eventData.message && (
        <EventsModalDetail label={'Message: '} value={eventData.message} textSeparator={true} />
      )}
      <Button className={classes.close} onClick={() => setShowModal(false)}>
        Close
      </Button>
    </div>
  );
};

export default EventsModal;
